export const REVIEWS_SECTION_ID = 'product-reviews';

export {
  INLINE_LINK_CLASS,
  PRODUCT_GRID_CLASS,
  PRODUCT_ROW_CLASS,
  PRODUCT_ROW_MAX_CARDS,
  SECTION_TITLE_CLASS,
} from '~/pages/DubaiExpress/constants';
